import { useApi } from '~/api'
import type { StringObject } from '~/types/common'
import type { UserActivityMessage } from '~/types/user-activity'
import type { UserActivityResponse } from '~/api/services/beacon'

export type BeaconVerb = 'CREATE' | 'READ' | 'UPDATE' | 'DELETE'
export type BeaconResource = 'user_activity'

export interface BeaconPayload {
  action: string
  resource: string
  timestamp: string
  metadata: Record<string, string>
}

export interface UseBeaconReturn {
  send: (verb: BeaconVerb, event: BeaconResource, metadata?: StringObject) => void
  sendUserActivity: (message: UserActivityMessage) => Promise<UserActivityResponse>
}

export const useBeacon = (): UseBeaconReturn => {
  const send = (verb: BeaconVerb, event: BeaconResource, metadata?: StringObject): void => {
    const payload: BeaconPayload = {
      action: `${verb}`,
      resource: `${event}`,
      timestamp: new Date().toISOString(),
      metadata: metadata || {}
    }

    // Todo: Use navigator.sendBeacon when API supports analytics without licence in the header
    // if (navigator.sendBeacon) {
    //   const config = useRuntimeConfig().public
    //   const serverUrl = config.apiUrl
    //   console.log('Beacon URL:', serverUrl)
    //   navigator.sendBeacon(serverUrl + '/beacon', JSON.stringify(payload))
    // } else {
    const api = useApi()
    api.beacon.send(payload)
    // }
  }

  const sendUserActivity = async (message: UserActivityMessage): Promise<UserActivityResponse> => {
    const api = useApi()
    return await api.beacon.sendUserActivity(message)
  }

  return {
    send,
    sendUserActivity
  }
}
